import { get } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

const getAssetHierarchyLevels = assetTypeId => get(`${url}/asset/hierarchy/${assetTypeId}`);

const getAssetTypes = () => {
  return get(`${url}/asset/assetType`);
};

const getAssetDefaults = () => {
  return get(`${url}/asset/default`);
};

const getAssetDefaultsAlpha = () => {
  return get(`${url}/asset/defaultAlpha`);
};

const getAssetHierarchyProperties = assetHierarchyId => {
  return get(`${url}/asset/hierarchy-properties/${assetHierarchyId}`);
};

const getAssets = (keyword, assetTypeId, buildYearAndMonth) => {
  if (!buildYearAndMonth) return get(`${url}/asset/${encodeURIComponent(keyword)}/${assetTypeId}`);
  return get(`${url}/asset/${encodeURIComponent(keyword)}/${assetTypeId}/${buildYearAndMonth}`);
};

const cacheAssetHierarchy = () => {
  return get(`${url}/asset/cache-asset-hierarchy`);
};

const exp = {
  getAssetHierarchyLevels,
  getAssetTypes,
  getAssetDefaults,
  getAssetDefaultsAlpha,
  getAssetHierarchyProperties,
  getAssets,
  cacheAssetHierarchy
};
export default exp;
